// QA opt-in flag for the new IA navigation (ZRM-16458). The cookie is injected
// via zillow-rental-manager-web's /featureFlags page (which registers the same
// key in its FeatureFlagConstants). Read directly here so the shared nav module
// can branch without prop-drilling the flag from every consuming app.
export const ZRM_IA_NAV_ENABLED = 'ZRM_IA_NAV_ENABLED';

// SSR-safe boolean cookie reader. Mirrors zrmw's getCookieAsBoolean: a value of
// 'true' or '1' is truthy. Returns false on the server (no document).
export function getCookieAsBoolean(name: string) {
  if (typeof document === 'undefined') return false;

  const match = document.cookie.split('; ').find((c) => c.startsWith(name + '='));
  if (!match) return false;

  const value = match.slice(name.length + 1);

  return value === 'true' || value === '1';
}
